import { IonicModule } from "@ionic/angular";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HelpSliderPage } from "./help-sliders.page";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
  imports: [IonicModule, CommonModule, TranslateModule],
  declarations: [HelpSliderPage],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],

})
export class HelpSliderPageModule {}
